import axios from 'axios';
import * as _ from 'lodash';
import { store } from './reducers';
import {baseApiURL} from "./Utils/urls";
import {encryptData, decryptData} from "./Helper/EncryptionDecryption";

const api = axios.create({
  baseURL: baseApiURL,
});

api.interceptors.request.use((config) => {
  const state = store.getState();
const uniquetokennew = state.adminUser.adminUser.apiToken; 
  const language = _.get(state, 'adminUser.adminUser.language', null);
  const configCopy = { ...config };
  if(configCopy.data && configCopy.data != undefined && !(configCopy.data instanceof FormData)){
    configCopy.data.userAuthId = state.adminUser.adminUser.userId;
    configCopy.data.encryptiondta = true;
    configCopy.data = {token: encryptData(configCopy.data)};
  }
  if (uniquetokennew) {
    configCopy.headers['Authorization'] = `${uniquetokennew}`// Corrected the format of the Authorization header
  }
  if (language) {
    configCopy.headers['language'] = `${language}`;
  } else {
    configCopy.headers['language'] = 'en';
  }

  return configCopy;
});

// ================================
// api.interceptors.request.use(config => {
//   const state = store.getState();
//   const uniquetokennew = state.adminUser.adminUser.apiToken; // Corrected the path to the token
//   console.log(state, uniquetokennew, "uniquetokennew");
//   if (uniquetokennew) {
//     console.log(uniquetokennew, "uniquetokennew 15");
//     config.headers.Authorization = `${uniquetokennew}`; // Corrected the format of the Authorization header
//   }
//   return config;
// }, error => {
//   return Promise.reject(error);
// });
// =================================

// Double-submit prevention: block identical concurrent write requests only
// Read endpoints (getAll, get-user, etc.) are excluded — they're safe to call in parallel
const pendingRequests = new Map<string, boolean>();
const WRITE_PATTERNS = ['/create', '/add', '/update', '/delete', '/redeem', '/bulkUpload'];

api.interceptors.request.use((config: any) => {
  if (config.method === 'post' || config.method === 'put') {
    const url = config.url?.toLowerCase() || '';
    const isWrite = WRITE_PATTERNS.some(p => url.includes(p));
    if (isWrite) {
      const key = `${config.method}:${config.url}:${JSON.stringify(config.data)}`;
      if (pendingRequests.has(key)) {
        const cancelSource = axios.CancelToken.source();
        config.cancelToken = cancelSource.token;
        cancelSource.cancel('Duplicate request blocked');
        return config;
      }
      pendingRequests.set(key, true);
      config._dedupKey = key;
    }
  }
  return config;
});

api.interceptors.response.use((res: any) => {
  if (res.config?._dedupKey) {
    pendingRequests.delete(res.config._dedupKey);
  }
  try {
    res.data = decryptData(res.data);
  } catch (_e) {
    // Response was not encrypted (e.g. file upload endpoints) — use as-is
  }
  return res;
}, (error) => {
  if (error.config?._dedupKey) {
    pendingRequests.delete(error.config._dedupKey);
  }
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }
  const errorResponse = _.get(error, 'response.data', null);
  if (errorResponse) {
    // Error responses are not uniformly encrypted: the backend's
    // apiResponses helpers (notFoundResponse / unauthorizedResponse /
    // validationErrorWithData) send PLAIN JSON, while some paths send an
    // encrypted envelope. decryptData() throws on plain input, so try to
    // decrypt and fall back to the raw body when it isn't encrypted —
    // otherwise the real message (e.g. 'User Not found.') is lost.
    let errorResponse1;
    try {
      errorResponse1 = decryptData(errorResponse);
    } catch (e) {
      errorResponse1 = errorResponse;
    }
    if (!errorResponse1 || typeof errorResponse1 !== 'object') {
      errorResponse1 = errorResponse;
    }
    if(errorResponse1.message == "You are not authorized" || errorResponse1.message == "User not found"){
      // Auth-failure logout: preserve the language preference across the
      // localStorage wipe so the login page keeps the user's chosen language.
      let savedLang: string | null = null;
      try { savedLang = localStorage.getItem('userLanguagePreference'); } catch (e) { /* storage unavailable — non-fatal */ }
      localStorage.clear();
      try { if (savedLang) { localStorage.setItem('userLanguagePreference', savedLang); } } catch (e) { /* storage unavailable — non-fatal */ }
      window.location.href = "/";
    }

    // Ensure we are throwing a string message, not an object
    const errorMessage = typeof errorResponse1.message === 'object'
      ? JSON.stringify(errorResponse1.message)
      : (errorResponse1.message || "Unknown Error");

    throw new Error(errorMessage);
  }
  throw new Error(error.message);
});

export { api };
